module.exports = __webpack_public_path__ + "static/media/Blog Post Photos.c3ac134b.PNG";